import * as React from "react";
import {RemovableTagModal} from "../util/RemovableTagModal";
import {USER_SERVICE_NAME, UserService} from "../../service/admin/UserService";
import {AppCtx} from "../../ioc/ApplicationContext";
import {FormGroup} from "../form/FormGroup";
import {FormControl} from "react-bootstrap";
import {DeleteButtonModal} from "../util/DeleteButtonModal";
import {DateUtil} from "../util/date";


export interface RUGPanelState {
    rugs: any[];
    addRugValue: string;
    inputDisabled: boolean;
    showLoading: boolean;
    addRugError: string;
}

export interface RUGPanelProps {
    attributes: { [key: string]: string };
    header: string;
    hideTableHeader?: boolean;
    user;
}

export class RUGPanel extends React.Component<RUGPanelProps, RUGPanelState> {
    static readonly RUG_PREFIX = "RUG_";
    userService: UserService;

    public static decodeTag(tag: string) {
        return decodeURIComponent(tag.substr(RUGPanel.RUG_PREFIX.length)).replace(/\+/g, ' ');
    }

    constructor(props) {
        super(props);
        this.state = {rugs: [], addRugValue: "", inputDisabled: false, showLoading: false, addRugError: ""};
        this.userService = AppCtx.resolve<UserService>(USER_SERVICE_NAME);
        this.getAllRUGDetails();
    }

    renderTH() {
        if (this.props.hideTableHeader == true) {
            return (<thead/>);
        }

        return (
            <thead>
            <tr>
                <th>RUG</th>
                <th>Date Added</th>
                <th>Other Players</th>
                <th>Actions</th>
            </tr>
            </thead>
        )
    }

    onRugAdd(event) {
        event.preventDefault();
        if (this.state.addRugValue.trim().length == 0) {
            this.setState({
                rugs: this.state.rugs,
                addRugValue: this.state.addRugValue,
                inputDisabled: this.state.inputDisabled,
                showLoading: this.state.showLoading,
                addRugError: "The RUG must contain characters"
            });

            return;
        }
        let key = RUGPanel.RUG_PREFIX + this.state.addRugValue;
        let date = DateUtil.getUtcDateString();
        let target = event.target;

        // if it exists
        if (this.state.rugs.filter((rug) => (rug.RUGKey.toLowerCase() == key.toLowerCase())).length == 1) {
            // stop and show an error
            this.setState({
                rugs: this.state.rugs,
                addRugValue: this.state.addRugValue,
                inputDisabled: this.state.inputDisabled,
                showLoading: this.state.showLoading,
                addRugError: "This RUG already exists"
            });
            return;
        }

        this.setState({
            rugs: this.state.rugs,
            addRugValue: this.state.addRugValue,
            inputDisabled: true,
            showLoading: true,
            addRugError: ""
        });
        this.userService.addAttribute(this.props.user.userId, key, date).then(() => {
                target.reset();
                this.props.attributes[key] = date;
                this.getRUGDetails(key);
                this.setState({
                    rugs: this.state.rugs,
                    addRugValue: "",
                    inputDisabled: false,
                    showLoading: false,
                    addRugError: ""
                });
            }
        ).catch(() => this.setState({
            rugs: this.state.rugs,
            addRugValue: this.state.addRugValue,
            inputDisabled: false,
            showLoading: false,
            addRugError: "Something went wrong on the server"
        }));
    }

    onRugAddChange(event) {
        let val = event.target.value.replace(/[^a-zA-Z0-9-_ ]/g, "").substring(0, 32 - RUGPanel.RUG_PREFIX.length).toLowerCase();
        this.state.addRugValue = val;
        event.target.value = val;
    }

    getAllRUGDetails() {
        this.state.rugs = [];
        for (let x in this.props.attributes) {
            if (x.substr(0, 4) == RUGPanel.RUG_PREFIX) {
                this.getRUGDetails(x);
            }
        }

        this.setState({
            rugs: this.state.rugs,
            addRugValue: this.state.addRugValue,
            inputDisabled: this.state.inputDisabled,
            showLoading: this.state.showLoading,
            addRugError: this.state.addRugError
        });

    }

    getRUGDetails(key: string) {
        let attrs = this.state.rugs;
        let decodedLabel = RUGPanel.decodeTag(key);
        attrs.push({
            "RUGKey": key,
            "RUGLabel": decodedLabel,
            "RUGValue": this.props.attributes[key],
            "players": [],
            "loaded_players": false
        });
    }

    getRUGPlayers(rug: any) {
        this.userService.getPlayersWithAttribute(rug.RUGKey).then((results) => {
            rug.players = results.users.filter((player) => player.userId != this.props.user.userId);
            rug.loaded_players = true;
            this.setState({
                rugs: this.state.rugs,
                addRugValue: this.state.addRugValue,
                inputDisabled: this.state.inputDisabled,
                showLoading: this.state.showLoading,
                addRugError: this.state.addRugError
            });
        });
    }

    playerRemove(key: string, userId: number) {
        this.setState({
            rugs: this.state.rugs,
            addRugValue: this.state.addRugValue,
            inputDisabled: true,
            showLoading: true,
            addRugError: this.state.addRugError
        });
        return this.userService.removeAttribute(userId, key).then(() => {
            this.state.showLoading = false;
            let rugs = this.state.rugs;

            if (userId == this.props.user.userId) {
                // remove the rug
                rugs = rugs.filter((rug) => rug.RUGKey != key);
            }
            else {
                // remove the other player from the rug
                let rug = this.state.rugs.filter((rug) => (rug.RUGKey == key)).pop();
                rug.players = rug.players.filter((p) => p.userId != userId);
                this.getRUGDetails(key);
            }

            this.setState({
                rugs: rugs,
                addRugValue: this.state.addRugValue,
                inputDisabled: false,
                showLoading: this.state.showLoading,
                addRugError: this.state.addRugError
            });

        });
    }

    renderRUGs() {
        return this.state.rugs.map((rug) => {
            return this.renderRUG(rug);
        });
    }

    renderRUG(rug: any) {
        return (
            <tr key={rug.RUGKey}>
                <td>{rug.RUGLabel}</td>
                <td>{rug.RUGValue}</td>
                <td>{this.renderPlayers(rug)}</td>
                <td width={"15%"}>
                    {((!this.state.inputDisabled) ?
                        <DeleteButtonModal key={rug.RUGKey} label={"Remove"}
                                           description={this.props.user.userName + " from RUG " + rug.RUGLabel}
                                           className={"btn btn-danger"}
                                           onDelete={this.playerRemove.bind(this, rug.RUGKey, this.props.user.userId)}/> :
                        <button className={"btn btn-danger"} disabled>Remove</button>)}
                </td>
            </tr>
        );
    }

    renderPlayers(rug: any) {
        if (rug.loaded_players) {
            return rug.players.map(p => {
                return <RemovableTagModal key={p.userId + "-remove"} className="btn-lg btn-danger"
                                          onDelete={(this.state.inputDisabled) ? undefined : this.playerRemove.bind(this, rug.RUGKey, p.userId)}
                                          label={"Remove"} title={"Confirm Removal"}
                                          description={p.userName + " from RUG " + rug.RUGLabel} tagName={p.userName}/>;
            });
        } else {
            return <button onClick={this.getRUGPlayers.bind(this, rug)} className="btn btn-info btn-sm">Load
                players</button>
        }
    }

    render() {
        return (
            <div className="ibox">
                <div className="ibox-content">
                    <h2>{this.props.header}</h2>
                    <form onSubmit={this.onRugAdd.bind(this)}>
                        <FormGroup className="form-group">
                            <label className="col-lg-2 control-label">{"Add RUG"}</label>
                            <div className="col-lg-7">
                                <FormControl type={"text"} className="form-control"
                                             onChange={this.onRugAddChange.bind(this)}
                                             disabled={this.state.inputDisabled}/>
                                <span
                                    className={"m-b-none " + ((this.state.addRugError != "") ? "text-danger" : " help-block")}>{(this.state.addRugError != "") ? this.state.addRugError : "Create/Add RUG for this player"}</span>
                            </div>
                            <div className="col-lg-2">
                                <button className="btn btn-primary">Add</button>
                            </div>
                            <div className="col-lg-1">
                                <i className={"fa fa-circle-o-notch fa-spin " + ((this.state.showLoading) ? "" : "hidden")}/>
                            </div>
                        </FormGroup>
                    </form>
                    <table className="table table-striped">
                        {this.renderTH()}
                        <tbody>
                        {this.renderRUGs()}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }


}



// WEBPACK FOOTER //
// ./src/app/ui/attributes/RUGPanel.tsx